




























































































































































































































































































import Enterprise from '@/datatypes/enterprise';
import User from '@/datatypes/user';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import EnterpriseUpdateDisplay from '@/components/enterprise/update/display.vue';
import EnterpriseUpdateForm from '@/components/enterprise/update/form.vue';
import EnterpriseChartDisplay from '@/components/enterprise/chart/display.vue';
import EnterpriseDocuments from '@/components/enterprise/EnterpriseDocuments.vue';
import EnterpriseUpdateRequest from '@/datatypes/enterprise/update-request';
import StripeSubscriptionDisplay from '@/components/stripe/subscription/display.vue';
import EnterpriseDocumentOverage from '@/components/enterprise/document/Overage.vue';
import EnterpriseSmsOverage from '@/components/enterprise/sms/Overage.vue';
import EnterpriseIdentityOverage from '@/components/enterprise/identity/Overage.vue';
import EnterpriseOverageInvoice from '@/components/enterprise/overage/Invoice.vue';
import EnterpriseLimitsView from '@/components/enterprise/limits/View.vue';
import StripeCustomerDisplay from '@/components/stripe/customer/display.vue';
import EnterpriseUsers from '@/components/enterprise/Users.vue';

export default Vue.extend({
  components: {
    EnterpriseUpdateDisplay,
    EnterpriseUpdateForm,
    EnterpriseChartDisplay,
    EnterpriseUsers,
    EnterpriseDocuments,
    EnterpriseDocumentOverage,
    EnterpriseSmsOverage,
    EnterpriseIdentityOverage,
    EnterpriseOverageInvoice,
    EnterpriseLimitsView,
    StripeSubscriptionDisplay,
    StripeCustomerDisplay,
  },
  data: () => ({
    enterprise: new Enterprise({}),
    documentsSentPerMonth: {},
    documentsByStatus: {},
    documentChartOptions: { responsive: true, height: 250, maintainAspectRatio: false },
    isUpdatingEnterprise: false,
    currentError: { message: '', active: false },
    errorMessage: '',
    isRequestingFreeForever: false,
    isRequestingUserTransfer: false,
    enterpriseService: new EnterpriseService(),
    businessTransfer: {
      enterpriseId: undefined,
      enterprise: new Enterprise({}),
    },
    users: [] as User[],
    showVerificationLink: false,
    showVerificationDialog: false,
  }),
  filters: {
    yesno(input) {
      if (input === true) return 'Yes';

      return 'No';
    },
  },
  methods: {
    requestUpdateEnterprise() {
      this.isUpdatingEnterprise = true;
    },

    resetBusinessTransfer() {
      this.businessTransfer = {
        enterpriseId: undefined,
        enterprise: new Enterprise({}),
      };
      this.isRequestingUserTransfer = false;
    },

    saveEnterprise() {
      const enterpriseId = this.$route.params.id;
      const updateRequest = new EnterpriseUpdateRequest(this.enterprise);

      this.enterpriseService.updateEnterprise(enterpriseId, updateRequest).then((response) => {
        this.isUpdatingEnterprise = false;
        this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
      }).catch((error) => {
        this.currentError.active = true;
        this.currentError.message = error.response.data.message;
      });
    },

    postMessage(message: string) {
      this.currentError.active = true;
      this.currentError.message = message;
    },

    cancelSaveEnterprise() {
      this.fetchEnterprise();
      this.isUpdatingEnterprise = false;
    },

    receivedEnterprise(enterprise) {
      this.enterprise = enterprise;
    },

    turnIntoFreeForever() {
      const levelParams = {
        kind: 0,
      };

      this.enterpriseService.changeEnterpriseLevel(this.$route.params.id, levelParams).then(
        () => {
          this.postMessage('Business level changed to free forever.');
          this.fetchEnterprise();
        },
      ).catch(() => {
        this.postMessage('Error setting level to free forever.');
      }).finally(() => {
        this.isRequestingFreeForever = false;
      });
    },

    checkUserTransfer() {
      this.enterpriseService.getEnterprise(this.businessTransfer.enterpriseId).then((response) => {
        this.businessTransfer.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
      }).catch(() => {
        this.postMessage('Business not found.');
      });
    },

    synchroniseSubscription() {
      this.enterpriseService.synchroniseSubscription(this.$route.params.id).then(() => {
        this.postMessage('Subscription synchronised.');
        this.fetchEnterprise();
      }).catch(() => {
        this.postMessage('Error synchronising subscription.');
      });
    },

    fetchEnterprise() {
      if (this.$route.params.id) {
        this.enterpriseService.getEnterprise(this.$route.params.id).then((response) => {
          this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
        });
      }
    },

    enterpriseReload(callback) {
      this.enterpriseService.getEnterprise(this.$route.params.id).then((response) => {
        this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
        if (typeof callback !== 'undefined') {
          callback();
        }
      });
    },

    usersLoaded(users) {
      this.users = users;
    },

    transferUser() {
      this.enterpriseService.migrateEnterprise(
        this.$route.params.id,
        this.businessTransfer.enterprise.id,
      ).then(() => {
        this.resetBusinessTransfer();
        this.$router.push(`/businesses/${this.businessTransfer.enterprise.id}?transfer_queued=1`);
      }).catch(() => {
        this.postMessage('Business migration failed.');
        this.resetBusinessTransfer();
      });
    },

    copyVerificationLink() {
      if (!this.enterprise.owner.verificationLink) return;

      const el = document.createElement('textarea');
      el.value = this.enterprise.owner.verificationLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.postMessage('Verification link copied to clipboard.');
    },
  },
  computed: {
    transferUserRequestFailureReasons(): string {
      const reasons = [] as string[];

      if (this.users.length > 1) reasons.push('The owner needs to be the sole business user.');
      if ((this.enterprise.owner.kind !== 0) && (this.enterprise.owner.kind !== 6)) {
        reasons.push('The owner needs to be either on Free Forever or Trial.');
      }

      return reasons.join(' ');
    },
    hasBusinessToTransfer(): boolean {
      return typeof this.businessTransfer.enterprise.id === 'string';
    },
  },
  mounted() {
    if (this.$route.query.transfer_queued) {
      this.postMessage('Business transfer queued. Check global events to view transfer status.');
    }
    this.fetchEnterprise();
  },
});
